import type { Dispatch } from "react";
import type { FigureRegionTileFragment } from "../../client/generated";
import { assertTypeName } from "../../client/guards";
import { RegionTile } from "../../regions/RegionTile";
import type { EditorAction } from "../../editor/reducers";

type Props = {
  fragment: FigureRegionTileFragment;
  figureAttributeId: string;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function FigureRegionTile({
  fragment,
  figureAttributeId,
  children,
  dispatch,
}: Props) {
  const figureAttribute = fragment.attributes.find(
    (a) => a.id === figureAttributeId,
  );
  assertTypeName(figureAttribute?.__typename === "FigureAttribute");

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile fragment={fragment} preview="" onClick={onClick}>
      {children}
    </RegionTile>
  );
}
